module.exports = __webpack_public_path__ + "img/horizontal_7_4_9016.971f1ff7.png";